<!--
 * @Descripttion: 已完结订单
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="finished-order-list">
    <xrk-table
      style="height: 650px"
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  XrkMessage,
  XrkMessageBox
} from 'xrk-components';

import { payedOrderPageList } from '../data-source/apis';
import {
  indexCol,
  orderNoCol,
  projectNameCol,
  customerNameCol,
  orderTypeCol,
  orderTimeCol,
  orderFinishTimeCol,
  csoPriceSumCol,
  csoPayProgressCol,
  payStatusCol,
  payPassagewayCol,
  csoPayTypeCol,
  payTypeCol
} from '../fields/columns';
import {
  orderNoSearch,
  projectNameSearch,
  customerNameSearch,
  orderTimeAtSearch,
  orderFinishTimeSearch,
  payStatusSearch,
  payPassagewayNameSearch,
  csoPayTypeSearch,
  supplierPayTypeSearch
} from '../fields/searchs';

import emitter from '../utils/event-bus';
import {
  batchDownLoadOrderPayDetailSupplier,
  batchDownLoadReceiptBySupplier
} from '@/common/hooks/order/order-download';

const xrkTableRef = ref<XrkTableRef>();
const router = useRouter();
const route = useRoute();

const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};

const selectionVal = computed(() => {
  return xrkTableRef.value?.getSelectionRows();
});

onMounted(() => {
  emitter.on('refresh-order-tabel', () => {
    onRefreshTabel();
  });
});
const searchedParams = ref({ payPassagewayCode: '' });

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置',
    beforeReset: () => {
      // 清除路由上的查询参数
      if (route.query.orderNo) {
        router.replace({
          query: { force: Date.now() }
        });
      }
    }
  },
  searchColumns: [
    { ...orderNoSearch, defaultValue: route.query.orderNo },
    projectNameSearch,
    customerNameSearch,
    orderTimeAtSearch,
    orderFinishTimeSearch,
    payStatusSearch,
    payPassagewayNameSearch,
    csoPayTypeSearch,
    supplierPayTypeSearch
  ],
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              v-resource={[['已完结订单_下载支付详情']]}
              type="primary2"
              onClick={async () => {
                if (!selectionVal.value.length) {
                  XrkMessage.error('请选择一条数据');
                  return;
                }
                const payPassagewayCode =
                  searchedParams.value.payPassagewayCode;
                if (!payPassagewayCode) {
                  XrkMessageBox.alert(
                    '当前状态不支持批量下载，请先选择支付通道搜索后操作'
                  );
                  return;
                }
                await batchDownLoadOrderPayDetailSupplier({
                  payPassagewayCode:
                    xrkTableRef.value.getSearchValue().payPassagewayCode,
                  supplierOrderList: selectionVal.value.map(item => {
                    return {
                      orderId: item.id,
                      projectId: item.projectId
                    };
                  })
                });
                //批量下载支付详情
              }}
            >
              下载支付详情
            </BaseButton>
            <BaseButton
              v-resource={[['已完结订单_下载回单']]}
              type="primary2"
              onClick={async () => {
                if (!selectionVal.value.length) {
                  XrkMessage.error('请选择一条数据');
                  return;
                }
                //批量下载回单

                await batchDownLoadReceiptBySupplier({
                  downloadType: 701,
                  downloadList: selectionVal.value.map(item => {
                    return {
                      id: item.id,
                      supplierOrderId: item.id,
                      orderType: item.orderType
                    };
                  })
                });
              }}
            >
              下载回单
            </BaseButton>
          </>
        );
      }
    }
  ]
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'id',
      align: 'center',
      fixed: 'left',
      width: 120
    }),
    indexCol,
    orderNoCol,
    projectNameCol,
    customerNameCol,
    orderTypeCol,
    orderTimeCol,
    orderFinishTimeCol,
    csoPriceSumCol,
    csoPayProgressCol,
    payStatusCol,
    payPassagewayCol,
    csoPayTypeCol,
    payTypeCol,
    useTableColumn({
      align: 'center',
      fixed: 'right',
      label: '操作',
      render({ row }) {
        return (
          <>
            <div>
              <BaseButton
                onClick={async () => {
                  // 查看明细
                  const routeData = router.resolve({
                    path: '/main/supplier/order/detail',
                    query: {
                      id: row.id,
                      isEdit: 0
                    }
                  });
                  window.open(routeData.href);
                }}
                type="text"
              >
                查看支付明细
              </BaseButton>
            </div>
          </>
        );
      }
    })
  ],
  baseConfig: {}
});

const getListAjax = async params => {
  const [orderStartTime, orderEndTime] = params.orderTime || ['', ''];
  const [orderFinishTimeStart, orderFinishTime] = params.orderFinishTime || [
    '',
    ''
  ];

  const reqData = {
    ...params,
    orderStartTime,
    orderEndTime,
    orderFinishTimeStart,
    orderFinishTime
  };
  const data = await payedOrderPageList(reqData);
  searchedParams.value = reqData;
  return data;
};
</script>
<style lang="scss"></style>
